<template>
  <div class="lh-15 c-666">
    <ProductBanner
      :banner-img="bannerImg"
      :product-name="$t('common.productName.powersec')"
      :main-title="'FJD PowerSec MP2000'"
      :sub-title="'Portable Power Station'"
    >
    </ProductBanner>
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor
        :product-name="$t('common.productName.powersec')"
        :is-show-overview="false"
        :is-show-features="false"
        :spec-url="'/product/powersecspec'"
      />
      <section class="area-1 pt-160 pb-160 bgc-FAFAFA">
        <div class="w-12r m-a d-f jc-sb">
          <div class="parameter-wrap d-f fd-c jc-fs">
            <template v-for="(item, index) in area1Param">
              <strong :key="Math.random(index)">{{ $t(item.bigText) }}</strong>
              <span :key="Math.random(index)">{{ $t(item.smallText) }}</span>
            </template>
          </div>
          <div class="media-wrap">
            <!-- todo -->
          </div>
        </div>
      </section>
      <!-- area-1:end -->
      <Application :app-h2="$t('products.powersec.area2Title')" :application-data="applicationData" />
      <!-- area-2:end -->
      <section class="area-3 bgs-cover ov-h mt-160">
        <div class="area-3-inner p-r ov-h">
          <h2 class="fs-48 ta-c c-fff">{{ $t('products.powersec.area3Title') }}</h2>
          <div class="area-3-icon-wrap ov-h">
            <ul class="d-f fw-w jc-sb">
              <li v-for="(item, index) in iconsData" :key="index">
                <div class="icon">
                  <svg-icon :icon-class="item.icon" />
                </div>
                <div class="icon-txt">
                  <strong>
                    <em>{{ item.value }}</em>
                    <i>{{ item.unit }}</i>
                  </strong>
                  <span>{{ item.subText }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- area-3:end -->
      <section class="area-4 bgs-cover p-r">
        <h2 class="fs-48 ta-c c-fff">1200W Fast Charge</h2>
        <div class="area-4-pic-1 p-a">
          <img src="@/assets/images/powersec/area-4-01.png" width="100%" height="100%" alt="1200W Fast Charge" />
        </div>
        <div class="area-4-pic-2 p-a">
          <img src="@/assets/images/powersec/area-4-02.png" width="100%" height="100%" alt="1200W Fast Charge" />
        </div>
      </section>
      <!-- area-4 -->
      <section class="area-5 bgc-fafafa">
        <div class="area-5-inner d-f">
          <div class="img-wrap">
            <img src="@/assets/images/powersec/area-5.png" width="100%" height="100%" alt="PowerSec" />
          </div>
          <div class="text-wrap d-f fd-c">
            <div>
              <strong class="d-b">PowerSec<em>- No Adapter Required</em></strong>
              <div>Lightweight and portable</div>
            </div>
            <div>
              <strong class="d-b">Traditional Power Station</strong>
              <div>Adapter required, Heavy and Not portable</div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-5:end -->
      <section class="area-6">
        <div class="area-6-inner">
          <h2 class="fs-48 c-fff ta-c">Replace Battery in 30s</h2>
          <div class="ta-c c-fff">Plug and play in 3 steps, ready to go</div>
          <div class="sequence m-a">
            <FrameSequence :img-list="squenceImgs" />
          </div>
        </div>
      </section>
      <!-- area-6:end -->
      <section class="area-7 bgc-fafafa">
        <h2 class="fs-48 ta-c mb-32 c-333">12 Output Ports Meet Multiple Devices</h2>
        <ul class="d-f jc-sb">
          <li v-for="(item, index) in outputPorts" :key="index">
            <div class="img-wrap">
              <img :src="item.imgs" width="100%" height="100%" :alt="item.text1" />
            </div>
            <div class="text-wrap d-f fd-c ta-c">
              <strong class="d-b" v-html="item.text1"></strong>
              <span class="d-b" v-html="item.text2"></span>
            </div>
          </li>
        </ul>
      </section>
      <!-- area-7:end -->
      <section class="area-8 pt-160">
        <div class="w-12r m-a d-f jc-sb">
          <div class="text-wrap d-f fd-c jc-c">
            <h2 class="fs-48 c-333">Ultra Protection</h2>
            <strong class="d-b fs-32">Automotive Battery</strong>
            <div>
              Ultra metal protection, safer Soft packing lithium ion battery,more capacity in the same volume IP54, more
              durable
            </div>
          </div>
          <div class="img-wrap">
            <SingleVideo :video-info="area8VideoData" />
          </div>
        </div>
      </section>
      <!-- area-8:end -->
      <section class="area-9">
        <VerticalCarousel
          id="function"
          carousel-h3="Ultra Protection"
          :swiper-option="area9SwiperOption"
          :swiper-data="area9SwiperData"
        />
      </section>
      <!-- area-9:end -->
      <section class="area-10 pt-160">
        <div class="w-12r m-a">
          <h2 class="fs-48 c-333 ta-c mb-32">{{ $t('products.powersec.area10VideoTitle') }}</h2>
          <SingleVideo :video-info="area10VideoData" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'

  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import Application from '@/components/Application'
  import VerticalCarousel from '@/components/Carousel/VerticalCarousel'
  import SingleVideo from '@/components/SingleVideo'
  import FrameSequence from '@/components/FrameSequence'

  import bannerScroll from '@/mixins/bannerScroll.js'

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      Application,
      VerticalCarousel,
      SingleVideo,
      FrameSequence
    },
    mixins: [bannerScroll],
    data() {
      return {
        bannerImg: require('@/assets/images/powersec/banner.jpg'),
        area1Param: [
          {
            bigText: 'products.powersec.area1Param1BigText',
            smallText: 'products.powersec.area1Param1SmallText'
          },
          {
            bigText: 'products.powersec.area1Param2BigText',
            smallText: 'products.powersec.area1Param2SmallText'
          },
          {
            bigText: 'products.powersec.area1Param3BigText',
            smallText: 'products.powersec.area1Param3SmallText'
          },
          {
            bigText: 'products.powersec.area1Param4BigText',
            smallText: 'products.powersec.area1Param4SmallText'
          }
        ],
        applicationData: [
          {
            imgUrl: require('@/assets/images/powersec/area-2-1.jpg'),
            imgDesc: 'products.powersec.area2Img1Desc'
          },
          {
            imgUrl: require('@/assets/images/powersec/area-2-2.jpg'),
            imgDesc: 'products.powersec.area2Img2Desc'
          },
          {
            imgUrl: require('@/assets/images/powersec/area-2-3.jpg'),
            imgDesc: 'products.powersec.area2Img3Desc'
          },
          {
            imgUrl: require('@/assets/images/powersec/area-2-4.jpg'),
            imgDesc: 'products.powersec.area2Img4Desc'
          }
        ],
        iconsData: [
          {
            icon: 'pw-app-icon01',
            value: '30+',
            unit: 'Times',
            subText: 'Drone - 60w'
          },
          {
            icon: 'pw-app-icon02',
            value: '14',
            unit: 'Times',
            subText: 'Electric Kettle - 1500 w '
          },
          {
            icon: 'pw-app-icon03',
            value: '30+',
            unit: 'Times',
            subText: 'Laptop - 60Wh'
          },
          {
            icon: 'pw-app-icon04',
            value: '2',
            unit: 'Hours',
            subText: 'Rice Cooker - 1000W'
          },
          {
            icon: 'pw-app-icon05',
            value: '1.1~6.4',
            unit: 'Hours',
            subText: 'Hair Dryer - 1600W'
          },
          {
            icon: 'pw-app-icon06',
            value: '30~36',
            unit: 'Hours',
            subText: 'CPAP - 40W'
          },
          {
            icon: 'pw-app-icon07',
            value: '11~13h',
            unit: 'Hours',
            subText: 'Air Pump -140W'
          },
          {
            icon: 'pw-app-icon08',
            value: '1.8~2',
            unit: 'Hours',
            subText: 'Spotlight -1000W'
          },
          {
            icon: 'pw-app-icon09',
            value: '180+',
            unit: 'Times',
            subText: 'Phone -10Wh'
          },
          {
            icon: 'pw-app-icon10',
            value: '1.1~3',
            unit: 'Hours',
            subText: 'Electric Stove -1800W'
          },
          {
            icon: 'pw-app-icon11',
            value: '110+',
            unit: 'Times',
            subText: 'Camera -16Wh'
          },
          {
            icon: 'pw-app-icon12',
            value: '2~4',
            unit: 'Hours',
            subText: 'Electric Drill -1000W'
          },

          {
            icon: 'pw-app-icon13',
            value: '(15A)9~11',
            unit: 'Km',
            subText: 'EV -1700W'
          },
          {
            icon: 'pw-app-icon14',
            value: '5~6',
            unit: 'Hours',
            subText: 'Oxygenerator -320W'
          },
          {
            icon: 'pw-app-icon15',
            value: '16~17h',
            unit: 'Hours',
            subText: 'Projector -100W'
          },
          {
            icon: 'pw-app-icon16',
            value: '2',
            unit: 'Times',
            subText: 'Drone Sprayer -800Wh'
          },
          {
            icon: 'pw-app-icon17',
            value: '1~8',
            unit: 'Hours',
            subText: 'Electric Cutter - 200~2000W'
          },
          {
            icon: 'pw-app-icon18',
            value: '1.6',
            unit: 'Hours',
            subText: 'Lawn Mower -1100W'
          },
          {
            icon: 'pw-app-icon19',
            value: '16~17h',
            unit: 'Hours',
            subText: 'Video Camera -100W'
          },
          {
            icon: 'pw-app-icon20',
            value: '2~7',
            unit: 'Hours',
            subText: 'Air Conditioner -1200W'
          },
          {
            icon: 'pw-app-icon21',
            value: '16~32',
            unit: 'Hours',
            subText: 'Refrigerator -1200W'
          },
          {
            icon: 'pw-app-icon22',
            value: '80~100',
            unit: 'Cups',
            subText: 'Coffee Maker -600W'
          },
          {
            icon: 'pw-app-icon23',
            value: '3~4h',
            unit: 'Hours',
            subText: 'Washer -500W'
          },
          {
            icon: 'pw-app-icon24',
            value: '1~1.5',
            unit: 'Hours',
            subText: 'Electric Heater -1300W'
          }
        ],
        outputPorts: [
          {
            imgs: require('@/assets/images/powersec/area-7-01.jpg'),
            text1: 'Household Electric Appliances',
            text2: 'AC output : 2000W *3'
          },
          {
            imgs: require('@/assets/images/powersec/area-7-02.jpg'),
            text1: 'Car refrigerator, car vacuum cleaner',
            text2: 'Car charging : 12V 8A *1<br>DC55*2.5 : 12V 4A *2'
          },
          {
            imgs: require('@/assets/images/powersec/area-7-03.jpg'),
            text1: '3C devices, Fast Recharging',
            text2: 'Type-C PD : 60W *2<br>USB 3.0 : 18W *4'
          }
        ],
        area8VideoData: {
          isAnimation: true,
          poster:
            '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ff12eba73701925925826941018/sampleSnapshot/sampleSnapshot_10_0.jpg',
          dataSrc: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/ff12eba73701925925826941018/rAmOMlmTHwwA.mp4'
        },
        area9TabItem: ['products.powersec.area9Tab1', 'products.powersec.area9Tab2', 'products.powersec.area9Tab3'],
        area9SwiperOption: {
          el: '',
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          autoplay: { delay: 3000 },
          pagination: {
            el: ' .vertical-swiper-style .vertical-swiper-pagination ul',
            clickable: true,
            renderBullet: (index, className) => {
              return (
                '<li class="' +
                className +
                '"><div class="pagination-item">' +
                this.$t(this.area9TabItem[index]) +
                '</div></li>'
              )
            }
          }
        },
        area9SwiperData: [
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bfe07d2f3701925925785603189/g4TZg6cLujEA.mp4',
            poster:
              '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bfe07d2f3701925925785603189/sampleSnapshot/sampleSnapshot_10_0.jpg'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/0f4213ab3701925925786713713/zlxBAQb4aSgA.mp4',
            poster:
              '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/0f4213ab3701925925786713713/sampleSnapshot/sampleSnapshot_10_0.jpg'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/0f4213af3701925925786713717/e8v9GPLyPhEA.mp4',
            poster:
              '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/0f4213af3701925925786713717/sampleSnapshot/sampleSnapshot_10_0.jpg'
          }
        ],
        area10VideoData: {
          isAnimation: true,
          poster:
            '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/517492123701925925834955097/sampleSnapshot/sampleSnapshot_10_0.jpg',
          dataSrc: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/517492123701925925834955097/lu4xpZv82qAA.mp4'
        },
        squenceImgs: []
      }
    },
    head() {
      return {
        title: 'FJD PowerSec - FJDynamics',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'FJD, FJDynamics, power bank, portable power station'
          },
          {
            hid: 'description',
            name: 'description',
            content:
              '2000W Power Station with Removable Batteries. Full Power Again in Seconds, 2264Wh King Capacity, Removable Battery Pack, 2H Fast Charging'
          }
        ]
      }
    },
    created() {
      const imags = require.context('@/assets/images/powersec/03', false, /\.png$/)
      this.squenceImgs = imags.keys().map(imags)
    },
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        gsap.registerPlugin(ScrollTrigger)
        this.iconAnimationHandler()
      }
    },
    methods: {
      iconAnimationHandler() {
        gsap.to('.area-3-inner ul', {
          scrollTrigger: {
            trigger: '.area-3-inner',
            start: 'center-=100 center',
            end: 'center-=100 center',
            scrub: 1
            // pin:true,
            // markers: true,
          },
          y: '-50%'
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .fs-48 {
    font-size: 0.48rem;
  }
  .fs-32 {
    font-size: 0.32rem;
  }
  .mb-32 {
    margin-bottom: 0.32rem;
  }

  .area-1 {
    .parameter-wrap {
      margin-top: 0.24rem;
      width: 1.96rem;
      color: #333;
      strong {
        font-size: 0.4rem;
        padding-bottom: 0.12rem;
        margin-bottom: 0.12rem;
        line-height: 0.9;
        border-bottom: 1px solid #999;
      }
      span {
        margin-bottom: 0.48rem;
        font-size: 0.2rem;
        &:nth-of-type(4) {
          margin-bottom: 0;
        }
      }
    }
    .media-wrap {
      width: 9.72rem;
      height: 5.47rem;
      background: #ccc;
    }
  }

  .area-2 {
    .stagger-style1 li {
      width: 2.88rem;
      height: 5.1rem;
      position: relative;
      .text-wrap {
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.32rem;
        text-align: center;
        font-size: 0.24rem;
        font-weight: 500;
      }
    }
  }

  .area-3 {
    height: 10.8rem;
    background-image: url('@/assets/images/powersec/area-3.jpg');
    .area-3-inner {
      position: sticky;
      top: 1rem;
      height: 7.4rem;
      margin: 1.4rem 3.52rem 2.04rem;
      .area-3-icon-wrap {
        position: sticky;
        top: 0;
        margin-top: 0.64rem;
      }
      li {
        display: flex;
        align-items: center;
        width: 25%;
        height: 2rem;
        padding-left: 0.64rem;
      }
      .icon {
        align-items: flex-start;
        width: 0.4rem;
        height: 0.4rem;
      }
      .icon-txt {
        margin-left: 0.16rem;
      }
      .icon-txt em {
        display: inline-block;
        padding-right: 0.08rem;
        color: #90f8e9;
        font-weight: 700;
        font-size: 0.24rem;
      }
      .icon-txt i {
        display: inline-block;
        color: #999;
        font-size: 0.12rem;
      }
      .icon-txt span {
        display: block;
        color: #fff;
        font-size: 0.16rem;
      }
      .svg-icon {
        width: 100%;
        height: 100%;
      }
    }
  }

  .area-4 {
    height: 7.4rem;
    background-image: url('@/assets/images/powersec/area-4.jpg');
    h2 {
      padding-top: 1.161rem;
    }
    .area-4-pic-1 {
      width: 5.11rem;
      height: 2.81rem;
      top: 3.56rem;
      left: 5.26rem;
    }
    .area-4-pic-2 {
      width: 3.88rem;
      height: 2.31rem;
      top: 3.34rem;
      left: 10.37rem;
      background: url('@/assets/images/powersec/area-4-03.png') center / cover;
      img {
        width: 2.88rem;
        height: 1.78rem;
        position: absolute;
        top: 0.24rem;
        left: 0.41rem;
      }
    }
  }

  .area-5 {
    padding: 1.88rem 0 2.09rem;
    .area-5-inner {
      margin-left: 4.58rem;
      .img-wrap {
        width: 6.33rem;
        height: 2.43rem;
      }
      .text-wrap {
        margin-left: 0.53rem;
        font-size: 0.16rem;
        & > div:nth-of-type(1) {
          margin: 0.23rem 0 0.87rem 0;
        }
        strong {
          font-size: 0.24rem;
          font-weight: 400;
          color: #333;
          em {
            font-size: 0.16rem;
            color: #3081f2;
          }
        }
      }
    }
  }

  .area-6 {
    background-color: #111;
    height: 230vh;
    .area-6-inner {
      position: sticky;
      top: 0.5rem;
    }
    h2 {
      padding-top: 1.6rem;
      padding-bottom: 0.24rem;
    }
    .sequence {
      margin-top: 0.32rem;
      width: 10rem;
      height: 5.63rem;
    }
  }

  .area-7 {
    padding: 1.6rem 0;
    ul {
      margin: 0 2.84rem;
    }
    li {
      width: calc((100% - 0.32rem) / 3);
      border: 1px solid #e5e5e5;
      background-color: #fff;
      box-sizing: border-box;
      .img-wrap {
        height: 2.48rem;
      }
      .text-wrap {
        height: 1.76rem;
        strong {
          padding: 0.32rem 0 0.08rem;
          font-size: 0.24rem;
          color: #333;
        }
      }
    }
  }

  .area-8 {
    .text-wrap {
      width: 3.46rem;
      strong {
        margin: 0.08rem 0 0.24rem;
      }
    }
    .img-wrap {
      width: 8.2rem;
      height: 4.62rem;
    }
  }

  .area-10 {
    padding-bottom: 2rem;
  }
</style>
